import React, { useMemo } from "react";

export default function useLabels(labels, lng) {
  return useMemo(() => ({
    ...labels['pl'],
    ...labels[lng]
  }), [labels, lng]);
}